import { render, staticRenderFns } from "./rightDraw.vue?vue&type=template&id=62c8f288&scoped=true&"
import script from "./rightDraw.vue?vue&type=script&lang=js&"
export * from "./rightDraw.vue?vue&type=script&lang=js&"
import style0 from "./rightDraw.vue?vue&type=style&index=0&id=62c8f288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c8f288",
  null
  
)

export default component.exports